export type EditBinderCostSettingsPageParams = Readonly<Record<'projectId', string | undefined>>;
export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const ROUTE_PATH = `/admin/projects/${ROUTE_PARAM_IDENTIFIER}/edit/binder-cost-settings`;
export const TITLE = 'Edit Binder Cost Settings';
